import { render } from "./InformeInter_MedInter.vue?vue&type=template&id=2873b157"
import script from "./InformeInter_MedInter.vue?vue&type=script&lang=js"
export * from "./InformeInter_MedInter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__